import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import {
  SUPPORTED_COMPONENTS,
  SUPPORTED_PROPERTIES,
} from '@savgroup-front-common/types';

import { getCustomComponentProperty } from '../../../helpers';

export const $Description = styled.div`
  white-space: pre-wrap;
  margin-bottom: ${spacing('lg')};
`;

export const $ActionRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: ${spacing('lg')};
`;

export const $BonusLine = styled.div`
  display: flex;
  gap: ${spacing('xxl')};
  padding: ${spacing('lg')};

  &:not(:last-child) {
    margin-bottom: ${spacing('lg')};
  }

  & a {
    padding-left: ${spacing(2.5)};
  }

  background-color: ${({ theme }) => {
    return getCustomComponentProperty({
      theme,
      componentName: SUPPORTED_COMPONENTS.CARD,
      property: SUPPORTED_PROPERTIES.COLORED_BACKGROUND_COLOR,
      fallback: theme.colors.white,
    });
  }};
`;
